import React, { Component } from 'react'
import MatrixModal from './MatrixModal'
import { nanoid } from 'nanoid'
import { checkTranslation, getObject, paramsToValue, setObject, translate } from '../../../utils/useful'
import Col from '../../kanban/columns/Col'
import Collapsible from 'react-collapsible'
import MatrixInfoCell from './MatrixInfoCell'
import StackedField from '../../inputs/StackedField'
import ActionButton from '../../partials/ActionButton'
import IntractionActionsList from '../../IntractionActionsList'
import ActionsBtn from '../../partials/ActionsBtn'

export default class Matrix extends Component {
    state = {

        topBox: [
            { title: "Unassigned", color: "#A6A6A6", },
            { title: "To Do", color: "#FF4B4B" },
        ],

        side: [
            { icon: "/assets/icons/person-empty.svg", title: "(empty)", },
            { icon: "/assets/icons/person.circle.fill.svg", title: "Username", },
        ],

        data: [
            { name: "Task number 1", priority: 'hight' },
            { name: "Task number 1", priority: 'hight' },
        ],
        groups: {},
        open: {},
        key: ['values.EXs1drDdNolhPWtn-QvqL', 'values.Eyhtt0-HwHzOfBKM3YBCz'],
        columns: {},
        rows: {},

    }

    componentDidMount() {
        this.init()
        // if (!this.props.view?.settings?.stacked) {
        //     this.props.openSelectStack()
        // }
    }

    componentDidUpdate(prevProps) {
        // console.log(this.props.view?.settings?.stacked)
        // console.log(this.state.view?.settings?.stacked)

        // console.log(JSON.stringify(this.props.view?.settings?.stacked) != JSON.stringify(prevProps.view?.settings?.stacked))
        if (JSON.stringify(this.props.view?.settings?.stacked) != JSON.stringify(this.state.view?.settings?.stacked) && (this.props.view?.type == 'Matrix' || this.props.view?.type == 'matrix')) {
            // console.log("WQDEJOKQ")
            this.init()
        }
        if (prevProps.data != this.props.data && (this.props.view?.type == 'Matrix' || this.props.view?.type == 'matrix')) {
            this.init()
        }

        if (prevProps.headers != this.props.headers) {
            this.init()
        }

    }

    init() {

        if (this.props.data) {
            // console.log('*Matrix View INIT', this.props.headers)
            // console.log('this.props.view?.settings?.stacked1', this.props.view?.settings)
            // console.log('this.state.view?.settings?.stacked', this.state.view?.settings?.stacked)
            let view = JSON.parse(JSON.stringify(this.props.view))
            this.setState({ view }, () => {
                // console.log("NITIT")
                let keys = this.props.view?.settings?.stacked
                let columns = {}
                let rows = {}

                // console.log('this.props.view, ', this.props.view)
                // console.log('keys, ', keys)

                if (keys?.row && keys?.column) {

                    let columnKey = paramsToValue(null, keys?.column, this.props.headers, 'View Record', true)
                    let rowKey = paramsToValue(null, keys?.row, this.props.headers, 'View Record', true)

                    // console.log(columnKey,rowKey)

                    // console.log(this.props.data)

                    columns = this.groupBy(0, this.props.data, [columnKey])
                    // return
                    rows = this.groupBy(0, this.props.data, [rowKey])

                    let columnHeader
                    let rowHeader

                    // console.log("this.props.headers")
                    // console.log(this.props.headers)


                    if (this.props.headers) {
                        this.props.headers.forEach(header => {
                            if (header.key == columnKey) {
                                columnHeader = header
                            }

                            if (header.key == rowKey) {
                                rowHeader = header
                            }

                        });


                        // this.props.headers.filter(h => h.key === keys?.row)[0]?.information?.items.map(i => columns[i.id] = i)
                        // this.props.headers.filter(h => h.key === keys?.column)[0]?.information?.items.map(i => rows[i.id] = i)

                        // console.log("this.props.data, ", this.props.data)
                        // console.log("temp1, ", rowsTemp)

                        // console.log('columns,', columns)
                        // console.log('rows,', rows)
                        this.setState({ columns, rows, columnHeader, rowHeader }, () => {
                            setTimeout(() => {
                                let groups = this.groupBy(0, this.props.data, [columnKey, rowKey])

                                // console.log("groups, ", groups)

                                this.setState({ groups })
                            }, 100)
                        })

                    }

                }
            })
        }
    }



    groupBy = (keyIndex = 0, data, keys, dontAddData) => {
        // console.log("======= groupBy =========")
        // console.log(keyIndex)

        if (keys && keys.length > 0) {
            if (keyIndex == 0) {
                this.setState({ orgData: this.props.data })
            }

            let group = {}
            let headers = this.props.headers

            if (data) {

                let key = keys[keyIndex]
                let header
                // console.log('matrixheaders', headers)
                headers?.forEach(element => {
                    if (key == element.key) {
                        header = element
                    }
                });

                if (Array.isArray(data)) {
                    data.forEach(element => {
                        // console.log(element)
                        let value = getObject(element, key)
                        // console.log(value)

                        if (Array.isArray(value)) {
                            value = value[value.length - 1]
                        }


                        let groupKey = value

                        if (groupKey == null || groupKey == undefined || groupKey == '') {
                            groupKey = "*undefined"
                            value = '{{lang}}Undefined'
                        }

                        value = String(value)

                        // console.log("groupKey, ", groupKey)

                        if (group[groupKey] == null) {
                            // console.log("NEWWW")
                            group[groupKey] = { data: [], fullData: element, info: value, header, id: nanoid() }
                        }
                        if (!dontAddData) {
                            group[groupKey].data.push(element)
                        }
                    });
                }
                if (keyIndex != keys.length - 1) {

                    for (const [groupKey, groupValues] of Object.entries(group)) {
                        group[groupKey] = { header, id: nanoid(), data: this.groupBy(keyIndex + 1, groupValues.data, keys, dontAddData) }
                    }
                }
                // console.log(group)
                if (keyIndex == 0) {
                    this.setState({ dataGroup: group })
                }
                // console.log('group======', group)
                // this.kanbanMaker(group, cb)

                return group

            }
        }
    }

    collaps = (id) => {
        let open = this.state.open
        open[id] = !open[id]
        this.setState({ open })

    }

    actionClicked = (prop, data, index) => {
        this.props.functionsHandler('collection', prop, data, index)
    }


    openSelectStack = () => {
        if (this.props.openSelectStack) {
            this.props.openSelectStack()
        } else {
            console.log(this.props.functionsHandler)

            if (this.props.functionsHandler) {
                this.props.functionsHandler(null, 'showConfig')
            }
        }
    }




    render() {
        // console.log(this.state.columns)
        let neededWidth = this.state.columns ? (Object.entries(this.state.columns).length * 180) + 140 : 200
        let width = neededWidth
        if (this.props.width > width) {
            width = this.props.width - 50
        }

        let stacked = this.props.view?.settings?.stacked
        // console.log('this.props.view?', this.props)

        return (

            <div className='h-100 w-100 position-relative'>
                {(stacked && stacked.row && stacked.column) ? (
                    <>
                        <div ref={el => this.mainContainer = el} className='w-100 window-content-radius h-100 d-flex flex-column scroll-no-scrollbar pb-0' style={{ backgroundColor: "#f0f0f0" }}>
                            {/* <p>{neededWidth}</p> 
                {this.props.width} */}




                            <div className='' style={{ width }}>
                                <div className='w-100 '>
                                    <div className=' '>
                                        <div className='w-100 d-flex' style={{ backgroundColor: '#fff', position: 'sticky', top: 0, zIndex: 2, minHeight: 50 }}>
                                            <div className=' ' style={{ position: 'sticky', left: 0, zIndex: 1, backgroundColor: '#fff', }}>
                                                <div className=' py-1 h-100 flexc ' style={{ width: 140, background: '#fcfcfc', borderRight: '1px solid #eee', borderBottom: '1px solid #eee' }}>
                                                    <div className='px-2 flexc ' style={{ width: 140, }}>
                                                        <p className='text-smaller text-semibold w-100' style={{ textOverflow: 'ellipsis', overflow: 'hidden', borderBottom: '0px solid #eee' }}>{checkTranslation(this.state.rowHeader?.information?.label)} / {checkTranslation(this.state.columnHeader?.information?.label)}</p>
                                                    </div>
                                                </div>
                                            </div>

                                            {this.state.columns && Object.entries(this.state.columns).map((column, index) => {
                                                return (
                                                    <div className='flexcc w-100  flex-1 py-2 px-2' style={{ backgroundColor: '#fcfcfc', minWidth: 180, borderRight: '1px solid #eee', borderBottom: '1px solid #eee' }}>
                                                        <MatrixInfoCell data={column} key={index} header={this.state.columnHeader} />
                                                    </div>
                                                )
                                            })}
                                        </div>

                                        {this.state.rows && Object.entries(this.state.rows)?.map((row, index) => {
                                            let topTopic = row[1]?.info
                                            let rowZ = [row[0], this.state.groups[row[0]]] ?? null
                                            return (
                                                <div className='w-100'>

                                                    <div className=' w-100 d-flex'>
                                                        <div className='' style={{ position: 'sticky', left: 0, zIndex: 1 }}>
                                                            <div className=' h-100 px-2 py-2' style={{ width: 140, backgroundColor: '#fcfcfc', borderRight: '1px solid #eee', borderBottom: '1px solid #eee' }}>
                                                                <MatrixInfoCell data={row} key={index} header={this.state.rowHeader} />
                                                            </div>
                                                        </div>
                                                        {Object.entries(this.state.columns).map((column, index) => {
                                                            let columnZ = [column[0], this.state.groups[column[0]]?.data[row[0]] ?? null]
                                                            return (
                                                                <div onDragOver={this.handleDragOver} onDrop={(event) => this.handleDrop(event, row, column)} className='p-1 position-relative  flex-1 pb-5' style={{ minWidth: 180, minHeight: "100px", backgroundColor: "#fff", borderRight: '1px solid #eee', borderBottom: '1px solid #eee' }}>
                                                                    <div className='w-100 h-100' draggable={false} style={{ background: "#fff", maxHeight: '300px', overflow: 'auto' }}>
                                                                        {/* {column[1]?.data.map((cdata, nindex) => { */}
                                                                        {this.state.groups[column[0]]?.data[row[0]]?.data?.map((record, nindex) => {
                                                                            // console.log('brow===', record)
                                                                            if (record) {
                                                                                let viewKey = this.props.view?.settings?.stacked?.viewKey
                                                                                viewKey = paramsToValue(null, viewKey, this.props.headers, 'View Record', true)
                                                                                let text = viewKey ? getObject(record, viewKey) : 'Record'

                                                                                // let columnKey = paramsToValue(null, keys?.column, this.props.headers, 'View Record', true)

                                                                                return (
                                                                                    <div draggable key={record._id} style={{ width: '100%' }} onClick={() => this.actionClicked('openEditModal', record, nindex)} onDragStart={(event) => this.handleDragStart(event, record, nindex, rowZ, columnZ)}>
                                                                                        <div id={record._id} className=' cursor-pointer ' onClick={() => this.collaps(record._id)}>
                                                                                            <div className='d-flex p-2 mb-1' style={{ background: '#f5f5f5', borderRadius: '6px' }}>

                                                                                                {this.props.actions && (
                                                                                                    <div className='mrd-2  flexcc' style={{}} onClick={(e) => e.stopPropagation()}>
                                                                                                        <ActionsBtn permissions={this.props.permissions} page={this.props.page} applet={this.props.applet} data={record} index={this.props.index} actions={this.props.actions} actionClicked={this.actionClicked} language={this.props.language} currentRecord={this.props.currentRecord} currentRecordStage={this.props.currentRecordStage} changeRecordStage={this.props.changeRecordStage} setCurrentRecordStage={this.props.setCurrentRecordStage} colors={this.props.colors} functionsHandler={this.props.functionsHandler} />
                                                                                                    </div>
                                                                                                )}

                                                                                                <div className="">
                                                                                                    <p className="text-small" >{text}</p>
                                                                                                </div>

                                                                                            </div>
                                                                                        </div>
                                                                                        {/* <Collapsible open={this.state.open[cdata._id]} >
                                                                                <div className='my-2 p-4 m-4 br-10 matrix-hover flexcb flex-wrap' style={{ backgroundColor: "#f6f6f6" }}>
                                                                                    <Col
                                                                                        actions={this.props.actions}
                                                                                        dataRow={cdata}
                                                                                        removeNewSubColumn={() => this.props.removeNewSubColumn(cdata._id)}
                                                                                        itemId={cdata._id}
                                                                                        key={cdata._id}
                                                                                        taskName={'taskName'}
                                                                                        index={nindex}
                                                                                        headersData={{ values: cdata.values }}
                                                                                        headers={this.props.headers} />
                                                                                </div>
                                                                            </Collapsible> */}
                                                                                    </div>
                                                                                )
                                                                            } else {
                                                                                return (
                                                                                    <>
                                                                                    </>
                                                                                )
                                                                            }
                                                                        })}
                                                                    </div>
                                                                    {/* <button className='position-absolute br-20 p-1' style={{ bottom: 3, right: 3, backgroundColor: "#f0f0f0" }} onClick={() => this.MatrixModal.modal.showModal()}>
                                                                        <img className='flexcc opacity-2' src='/assets/icons/useful/action.png' height={12} style={{}} />
                                                                    </button> */}
                                                                </div>
                                                            )
                                                        })}
                                                    </div>
                                                </div>
                                            )
                                        })}
                                    </div>
                                </div>
                            </div>
                            {/* <MatrixModal width={this.props.width} closeModal={() => this.MatrixModal.modal.hideModal()} ref={el => this.MatrixModal = el} data={this.state?.course} /> */}
                        </div>

                        {this.state.draggedItem && (
                            <>
                                <div onDragOver={() => this.scrollIndicatorOver('scrollLeft', -1)} style={{ height: '100%', width: 140, position: 'absolute', top: 0, left: 0, zIndex: 10 }}></div>
                                <div onDragOver={() => this.scrollIndicatorOver('scrollTop', -1)} style={{ height: 50, width: '100%', position: 'absolute', top: 0, left: 0, zIndex: 10 }}></div>
                                <div onDragOver={() => this.scrollIndicatorOver('scrollTop', 1)} style={{ height: 40, width: '100%', position: 'absolute', bottom: 0, left: 0, zIndex: 10 }}></div>
                                <div onDragOver={() => this.scrollIndicatorOver('scrollLeft', 1)} style={{ height: '100%', width: 40, position: 'absolute', top: 0, right: 0, zIndex: 10 }}></div>
                            </>
                        )}
                    </>
                ) : (
                    // <StackedField setData={this.props.setData} defaultStackedKey={this.props.defaultStackedKey} currentFrame={this.props.currentFrame} view={this.props.view} headers={this.props.headers} ref={el => this.StackedField = el} width={this.props.width} changeValue={this.props.changeStackedKey} colors={this.props.colors} />
                    <div className="flexcc w-100">
                        <div className=" pt-5 pb-5 px-3 flexcc flex-column text-center" >
                            <p className="py-1 text-bold text-big">{translate("Needs configuration")}</p>
                            <p className="py-1 text-small" style={{ maxWidth: 500 }}>{translate("For using matrix view, you need to do a configuration on the fields, use the botton below to do this configuration")}</p>

                            <button className="p-2 px-4 br-30  mt-2 text-semibold" onClick={() => this.openSelectStack()} style={{ background: '#007aff', color: '#fff' }} >
                                <p>{translate("Open Config")}</p>
                            </button>
                        </div>
                    </div>
                )}
            </div>
        )
    }



    scrollIndicatorOver = (side, value) => {

        this.mainContainer[side] = this.mainContainer[side] + value

    }


    handleDragStart = (event, item, index, row, column) => {

        // console.log(row)
        // console.log(column)
        // console.log(item)
        // console.log(index)

        this.setState({
            draggedItem: item,
            draggedIndex: index,
            draggedRow: row,
            draggedColumn: column,
        });
        // if (!this.state.verID) {
        //     this.setState({
        //         verID: ver[1].header.id,
        //         horID: hor[1].header.id,
        //     })
        // }

        // console.log(item)
        let i = document.getElementById(item._id)
        event.dataTransfer.setDragImage(i, 0, 0);

    };
    handleDragOver = (event) => {
        event.preventDefault();
    };

    handleDrop = (event, row, column) => {

        console.log("handleDrop")
        // console.log("row, ", row)
        // console.log("column, ", column)

        let draggedItem = { ...this.state.draggedItem }
        let draggedIndex = this.state.draggedIndex

        // console.log(draggedItem)
        // console.log(this.state.rowHeader)
        // console.log(this.state.columnHeader)

        let rowHeaderId = this.state.rowHeader?.key
        let colHeaderId = this.state.columnHeader?.key

        let rowNewKey = row[0] != '*undefined' ? row[0] : null
        let columNewKey = column[0] != '*undefined' ? column[0] : null


        // console.log("rowHeaderId, ", rowHeaderId)
        // console.log("colHeaderId, ", colHeaderId)


        // console.log("rowNewKey, ", rowNewKey)
        // console.log("columNewKey, ", columNewKey)


        let groups = this.state.groups

        // console.log(draggedItem)

        setObject(draggedItem, rowHeaderId, rowNewKey)
        setObject(draggedItem, colHeaderId, columNewKey)

        // console.log(draggedItem)

        // console.log("TP1")

        // return
        // draggedItem.values[this.state.verID] = row[0]
        // draggedItem.values[this.state.horID] = column[0]


        if (groups[column[0]]?.data) {

            if (!groups[column[0]].data[row[0]] || !groups[column[0]].data[row[0]].data) {
                groups[column[0]].data[row[0]] = { data: [] }
            }

            // if (groups[column[0]].data[row[0]]?.data) {
            groups[column[0]].data[row[0]].data.push(draggedItem)
            // } else {
            //     groups[row[0]].data[column[0]] = { data: [] }
            //     groups[row[0]].data[column[0]].data.push(draggedItem)
            // }
            // console.log("TP2")


        } else {

            // console.log("HEREEEE!!!")
            let data = {}
            data[row[0]] = { 'data': [] }
            groups[column[0]] = {}
            groups[column[0]]['data'] = data
            groups[column[0]].data[row[0]].data.push(draggedItem)

            // console.log("TP3")

        }

        // console.log(this.state.dragedRowKey)
        let dragedRowKey = this.state.draggedRow ? this.state.draggedRow[0] : this.state.draggedRow
        let draggedColumnKey = this.state.draggedColumn ? this.state.draggedColumn[0] : this.state.draggedColumn


        // console.log(groups)
        // console.log(dragedRowKey)
        // console.log(draggedColumnKey)

        // return

        // console.log("TP4")

        delete groups[draggedColumnKey].data[dragedRowKey].data[draggedIndex]

        // console.log("TP5")


        // data.forEach((i)=>{
        //     if (i._id === draggedItem._id){
        //         console.log('herrrrrrr',i,draggedItem)
        //         i = draggedItem
        //     }
        // })
        // console.log('herrrrrrr', data)


        // this.groupBy(0,data,this.state.key)

        // return
        this.setState({
            draggedItem: null,
            draggedIndex: null,
            draggedRow: null,
            draggedColumn: null,
            groups
        });


        this.props.submitForm(draggedItem, true)



    };
}
